import React, {Fragment} from "react";
import {withRouter} from "react-router-dom";
import {Card, CardBody, CardGroup, Col, Modal, ModalBody, Row} from "reactstrap";
import RegistrationStatusBadgeComponent from "./RegistrationStatusBadgeComponent";
import Transaction from "../domain/Transaction";
import CardDataComponent from "./CardDataComponent";
import SFXButtonComponent from "./SFXButtonComponent";
import ModalHeader from "react-bootstrap/ModalHeader";
import CreateObjectRowWithLabelComponent from "./CreateObjectRowWithLabelComponent";
import AgentPrivilege from "../enum/AgentPrivilege";
import UserSessionService from "../services/UserSessionService";
import ChatFromWithInContext from "./chat/ChatFromWithInContext";

const TRANSACTION_CONFIG = [
    {
        dataField: "date",
        label: "Date"
    },
    {
      dataField: "remittanceBrandReferenceNumber",
      label: "Reference Number"
    },
    {
        dataField: "dollarAmount",
        label: "Dollar Amount"
    },
    {
        dataField: "fees",
        label: "Fees"
    },
    {
        dataField: "vat",
        label: "VAT"
    },
    {
        dataField: "exchangeRate",
        label: "Exchange Rate"
    },
    {
        dataField: "destinationCountry",
        label: "Destination Country"
    }
];

class TransactionCardDataComponent extends React.Component {

    constructor(props) {
        super(props)

        this.agentCanChat = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_TRANSACTION_CHAT_CREATE) && !this.props.organisationsCanTransactIdsArrayIncludesAgentOrganisation ;

        this.state = {
            transactionList: this.props.transactions !== undefined ? this.props.transactions : [],
            isModalShowing: false,
            transactionBeingViewed: {}
        }
    }

    showModal(transaction) {
        this.setState({
            isModalShowing: true,
            transactionBeingViewed: transaction
        });
    }

    closedModal() {
        this.setState({
            isModalShowing: false,
            transactionBeingViewed: {}
        });
    }

    render() {
        return <Fragment>

            {
                this.state.transactionList.map((transaction, index) => {
                    return <CardGroup key={index}>
                        <Card>
                            <CardBody>
                                <div style={{display: "flex"}}>
                                    <h6 style={{
                                        flex: "5",
                                        fontWeight: "bold",
                                        fontSize: "20px",
                                        margin: "auto"
                                    }}>{transaction.beneficiaryFullName}</h6>

                                    <RegistrationStatusBadgeComponent
                                        status={transaction.status}
                                        statuses={Transaction.badgeColours}
                                    />
                                </div>
                                <br/>
                                <div style={{display: "flex"}}>
                                    <div style={{flex: "5"}}>
                                        <CreateObjectRowWithLabelComponent label={"Total"} className={"pull-left"}>
                                            {transaction.total}
                                        </CreateObjectRowWithLabelComponent>
                                    </div>
                                    <div style={{flex: "5", textAlign: "right"}}>
                                        <CreateObjectRowWithLabelComponent label={"Country"} className={"pull-left"}>
                                            {transaction.beneficiaryCountry}
                                        </CreateObjectRowWithLabelComponent>
                                    </div>
                                </div>
                                <div>
                                    <CreateObjectRowWithLabelComponent label={"Date"} className={"pull-left"}>
                                        {transaction.date}
                                    </CreateObjectRowWithLabelComponent>
                                </div>
                                <hr/>
                                <SFXButtonComponent color={"primary"} onClick={() => this.showModal(transaction)}>
                                    Details
                                </SFXButtonComponent>
                                <div style={{float: "right"}}>
                                {
                                    this.agentCanChat &&
                                    this.props.canChatForCustomer &&
                                    this.renderChat({resourceType: 'OUTBOUND_TRANSACTION_ID', resourceId: transaction.transactionId})
                                }
                                </div>
                            </CardBody>
                        </Card>
                    </CardGroup>
                })
            }

            {this.state.isModalShowing && this.renderModalForTransaction()}
        </Fragment>

    }

    renderModalForTransaction() {
        let transaction = this.state.transactionBeingViewed;

        return <Modal isOpen={this.state.isModalShowing}>
            <ModalHeader style={{display: "flex"}}>
                <h6 style={{
                    flex: "5",
                    fontWeight: "bold",
                    fontSize: "20px"
                }}>{transaction.beneficiaryFullName}</h6>
                <RegistrationStatusBadgeComponent
                    status={transaction.status}
                    statuses={Transaction.badgeColours}
                />
            </ModalHeader>
            <ModalBody>
                <CardDataComponent
                    data={transaction}
                    config={TRANSACTION_CONFIG}
                />
                <Row style={{float: "right", fontWeight: "bold", fontSize: "18px"}}>
                    <Col>{"R "}{transaction.total}</Col>
                </Row>
                <br/>
                <hr/>
                <SFXButtonComponent onClick={this.closedModal.bind(this)} className={"btn-secondary"}>
                    Back
                </SFXButtonComponent>

            </ModalBody>

        </Modal>
    }

    renderChat(context) {
        return <Fragment>
            <ChatFromWithInContext
                resourceType={context.resourceType}
                resourceId={context.resourceId}
            />
        </Fragment>
    }

}

export default withRouter(TransactionCardDataComponent);